var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning24Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 11,
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.79383 10.8149H11.2063C12.1688 10.8149 12.7688 9.77112 12.2876 8.93987L7.58133 0.808618C7.10008 -0.0226319 5.90007 -0.0226319 5.41883 0.808618L0.712576 8.93987C0.231326 9.77112 0.831326 10.8149 1.79383 10.8149ZM6.50008 6.43987C6.15633 6.43987 5.87508 6.15862 5.87508 5.81487V4.56487C5.87508 4.22112 6.15633 3.93987 6.50008 3.93987C6.84383 3.93987 7.12508 4.22112 7.12508 4.56487V5.81487C7.12508 6.15862 6.84383 6.43987 6.50008 6.43987ZM5.87508 8.93987H7.12508V7.68987H5.87508V8.93987Z",
    fill: "#FF1D1D",
    fillOpacity: 0.75
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning24Px);
export default __webpack_public_path__ + "static/media/warning_24px.6e94b3fbc221771acb417048ed49d800.svg";
export { ForwardRef as ReactComponent };